import RecommendedDeals from "./RecommendedDeals";

export default RecommendedDeals;
